import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBox, MessageBoxVariant, useTranslations } from "@jti/ui";
export const TrialBlockingCheckoutMessageBox = ({ isVisible }) => {
    const { __ } = useTranslations();
    return (_jsx(MessageBox, { variant: MessageBoxVariant.warning, isVisible: isVisible, children: __("libs.ui.notification.limit.trial") }));
};
//# sourceMappingURL=TrialBlockingCheckoutMessageBox.js.map